import _regeneratorRuntime from "@babel/runtime/regenerator";

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

// #region CONSTANTES
export var GET = "GET";
export var POST = "POST";
export var PUT = "PUT";
export var DELETE = "DELETE";
export var UNAUTHORIZED = 401;
export var FORBIDDEN = 403;
export var NOT_FOUND = 404;
export var NOT_SUPPORTED = 405;
export var WRONG_AUTHENTIFICATION = 419;
export var MAX_CONNEXION = 420;
export var DATA_ERROR = 422;
export var SAME_USER_ON_DATABASES = 432;
export var LICENCE_INVALID = 435;
export var SERVER_ERROR = 500; // #region

/**
 * Utilitaire pour la gestion des appels au serveur : Web service de type REST et données au format JSON
 * @category Data
 * @hideconstructor
 */

var RequestUtils = /*#__PURE__*/function () {
  function RequestUtils() {}

  // #region METHODES PUBLIQUES

  /**
   * Web service de type REST pour créer une ressource
   * @category RequestUtils
   * @param {string} urlBase URL de base
   * @param {string} sessionId Identifiant de session
   * @param {string} resource Nom de la ressource
   * @param {object} data Données à envoyer au format JSON
   * @param {boolean} [stayConnect=null] Indique si la connexion reste active ou non
   */
  RequestUtils.createResource = function createResource(urlBase, sessionId, resource, data, stayConnect) {
    if (stayConnect === void 0) {
      stayConnect = null;
    }

    return RequestUtils._sendRequest(sessionId, stayConnect, RequestUtils._constructUrl(urlBase, resource, null, null), POST, data, resource);
  }
  /**
   * Web service de type REST pour supprimer une ressource
   * @category RequestUtils
   * @param {string} urlBase URL de base
   * @param {string} sessionId Identifiant de session
   * @param {string} resource Nom de la ressource
   * @param {string} id Id de la ressource à supprimer
   * @param {boolean} [stayConnect=null] Indique si la connexion reste active ou non
   */
  ;

  RequestUtils.deleteResource = function deleteResource(urlBase, sessionId, resource, id, stayConnect) {
    if (stayConnect === void 0) {
      stayConnect = null;
    }

    return RequestUtils._sendRequest(sessionId, stayConnect, RequestUtils._constructUrl(urlBase, resource, id, null), DELETE, null, resource);
  }
  /**
   * Web service pour télécharger un fichier
   * @category RequestUtils
   * @param {string} urlBase URL de base
   * @param {string} sessionId Identifiant de session
   * @param {string} resource Nom de la ressource
   * @param {string} id Id de la ressource à télécharger
   * @param {boolean} [openNewTab=true] Ouverture dans un nouvel onglet
   * @param {boolean} [stayConnect=null] Indique si la connexion reste active ou non
   */
  ;

  RequestUtils.downloadFile = function downloadFile(urlBase, sessionId, resource, id, openNewTab, stayConnect) {
    if (openNewTab === void 0) {
      openNewTab = true;
    }

    if (stayConnect === void 0) {
      stayConnect = null;
    }

    var dlLink = document.createElement('a');
    var href = urlBase + "/" + resource + "/" + id + "?sessionId=" + sessionId;

    if (stayConnect !== null) {
      href = href + "&stayConnect=" + stayConnect;
    }

    dlLink.setAttribute("href", href);
    dlLink.setAttribute("download", "");

    if (openNewTab) {
      dlLink.setAttribute("target", "_blank");
      dlLink.setAttribute("rel", "noreferrer noopener");
    }

    dlLink.style.display = 'none';
    document.body.appendChild(dlLink);
    dlLink.click();
    document.body.removeChild(dlLink);
  }
  /**
   * Web service de type REST pour récupérer une ressource
   * @category RequestUtils
   * @param {string} urlBase URL de base
   * @param {string} sessionId Identifiant de session
   * @param {string} resource Nom de la ressource
   * @param {string} id Id de la ressource à récupérer
   * @param {boolean} [stayConnect=null] Indique si la connexion reste active ou non
   */
  ;

  RequestUtils.getResource = function getResource(urlBase, sessionId, resource, id, stayConnect) {
    if (stayConnect === void 0) {
      stayConnect = null;
    }

    return RequestUtils._sendRequest(sessionId, stayConnect, RequestUtils._constructUrl(urlBase, resource, id, null), GET, null, resource);
  }
  /**
   * Web service de type REST pour récupérer une liste de ressources
   * @category RequestUtils
   * @param {string} urlBase URL de base
   * @param {string} sessionId Identifiant de session
   * @param {string} resource Nom de la ressource
   * @param {boolean} [stayConnect=null] Indique si la connexion reste active ou non
   */
  ;

  RequestUtils.getResources = function getResources(urlBase, sessionId, resource, stayConnect) {
    if (stayConnect === void 0) {
      stayConnect = null;
    }

    return RequestUtils._sendRequest(sessionId, stayConnect, RequestUtils._constructUrl(urlBase, resource, null, null), GET, null, resource);
  }
  /**
   * Web service de type REST avec gestion de paramètres pour récupérer une liste de ressources
   * @category RequestUtils
   * @param {string} urlBase URL de base
   * @param {string} sessionId Identifiant de session
   * @param {string} resource Nom de la ressource
   * @param {array} params Paramètres de l'url sous forme d'un tableau de chaines clé=valeur ["cle1=val1", "cle2=val2"]
   * @param {boolean} [stayConnect=null] Indique si la connexion reste active ou non
   */
  ;

  RequestUtils.getResourcesWithParams = function getResourcesWithParams(urlBase, sessionId, resource, params, stayConnect) {
    if (stayConnect === void 0) {
      stayConnect = null;
    }

    return RequestUtils._sendRequest(sessionId, stayConnect, RequestUtils._constructUrl(urlBase, resource, null, params), GET, null, resource);
  }
  /**
   * Web service de type REST pour mettre à jour une ressource
   * @category RequestUtils
   * @param {string} urlBase URLl de base
   * @param {string} sessionId Identifiant de session
   * @param {string} resource Nom de la ressource
   * @param {string} id Id de la ressource à modifier
   * @param {object} data Données à envoyer au format JSON
   * @param {boolean} [stayConnect=null] Indique si la connexion reste active ou non
   */
  ;

  RequestUtils.updateResource = function updateResource(urlBase, sessionId, resource, id, data, stayConnect) {
    if (stayConnect === void 0) {
      stayConnect = null;
    }

    return RequestUtils._sendRequest(sessionId, stayConnect, RequestUtils._constructUrl(urlBase, resource, id, null), PUT, data, resource);
  } // #endregion
  // #region METHODES PRIVEES

  /**
   * Fonction permettant de construire l'url
   * @category RequestUtils
   * @private
   * @param {string} urlBase URL de base
   * @param {string} resource Nom de la ressource
   * @param {string} id Id de la ressource
   * @param {array} params Paramètres de l'url sous forme d'un tableau de chaines clé=valeur ["cle1=val1", "cle2=val2"]
   */
  ;

  RequestUtils._constructUrl = function _constructUrl(urlBase, resource, id, params) {
    var finalUrl = urlBase + "/" + resource; // Gestion d'un id

    if (id) {
      finalUrl += "/" + id;
    } // Gestion de paramètres


    if (params) {
      finalUrl += "?";

      for (var i = 0; i < params.length; i++) {
        if (i > 0) {
          finalUrl += "&";
        }

        finalUrl += params[i];
      }
    }

    return finalUrl;
  }
  /**
   * Fonction asynchrone d'envoi d'une requête au serveur
   * @category RequestUtils
   * @private
   * @param {string} sessionId Identifiant de session
   * @param {boolean} stayConnect Indique si la connexion reste active ou non
   * @param {string} url URL de la requête
   * @param {string} method Méthode de la requête (GET, POST, PUT ou DELETE)
   * @param {object} data Données de la requête au format JSON
   * @param {string} resource Nom de la ressource
   */
  ;

  RequestUtils._sendRequest =
  /*#__PURE__*/
  function () {
    var _sendRequest2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(sessionId, stayConnect, url, method, data, resource) {
      var requestConf, resultRequest;
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              // Configuration de la requête
              requestConf = {
                method: method,
                headers: {
                  Accept: "application/json",
                  "Content-Type": "application/json"
                }
              };

              if (sessionId) {
                // Ajout de l'id de session dans les headers
                requestConf.headers = _extends({}, requestConf.headers, {
                  "X-SessionId": sessionId
                });
              }

              if (stayConnect !== null) {
                // Ajout de l'état de la connexion dans les headers
                requestConf.headers = _extends({}, requestConf.headers, {
                  "X-StayConnect": stayConnect
                });
              } // Pas de body si GET ou données vide


              if (method !== GET && data) {
                requestConf.body = JSON.stringify(data);
              } // On attend le résultat avec await


              _context2.next = 6;
              return fetch(url, requestConf).then(function (response) {
                return response;
              })["catch"](function (error) {
                return error;
              });

            case 6:
              resultRequest = _context2.sent;
              return _context2.abrupt("return", new Promise( /*#__PURE__*/function () {
                var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(resolve, reject) {
                  var resp;
                  return _regeneratorRuntime.wrap(function _callee$(_context) {
                    while (1) {
                      switch (_context.prev = _context.next) {
                        case 0:
                          if (typeof resultRequest === "string") {
                            reject({
                              error: resultRequest,
                              status: 0
                            });
                          }

                          _context.next = 3;
                          return RequestUtils._manageResponse(resultRequest, sessionId, resource);

                        case 3:
                          resp = _context.sent;

                          if (resp.result) {
                            resolve(resp.response);
                          }

                          reject({
                            error: resp.error,
                            status: resp.status
                          });

                        case 6:
                        case "end":
                          return _context.stop();
                      }
                    }
                  }, _callee);
                }));

                return function (_x7, _x8) {
                  return _ref.apply(this, arguments);
                };
              }()));

            case 8:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));

    function _sendRequest(_x, _x2, _x3, _x4, _x5, _x6) {
      return _sendRequest2.apply(this, arguments);
    }

    return _sendRequest;
  }()
  /**
   * Fonction permettant de traiter la réponse
   * @category RequestUtils
   * @private
   * @param {object} response Les données de la réponse au format JSON
   * @param {string} sessionId Identifiant de session
   * @param {string} resource Nom de la ressource
   * @returns {object} Objet contenant les informations suivantes : result (true/false), response (données de la réponse au forma JSON), error (message d'erreur si présent), statuts (code HTTP de retour)
   */
  ;

  RequestUtils._manageResponse =
  /*#__PURE__*/
  function () {
    var _manageResponse2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(response, sessionId, resource) {
      var result, dataErrorMsg, serverErrorMsg;
      return _regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              result = {
                result: false,
                response: null,
                error: null,
                status: response.status
              };

              if (!response.ok) {
                _context3.next = 6;
                break;
              }

              result.result = true;
              result.response = response.json();
              _context3.next = 40;
              break;

            case 6:
              if (!response.status) {
                _context3.next = 39;
                break;
              }

              _context3.t0 = response.status;
              _context3.next = _context3.t0 === UNAUTHORIZED ? 10 : _context3.t0 === FORBIDDEN ? 12 : _context3.t0 === NOT_FOUND ? 14 : _context3.t0 === NOT_SUPPORTED ? 15 : _context3.t0 === WRONG_AUTHENTIFICATION ? 17 : _context3.t0 === MAX_CONNEXION ? 19 : _context3.t0 === LICENCE_INVALID ? 21 : _context3.t0 === SAME_USER_ON_DATABASES ? 23 : _context3.t0 === DATA_ERROR ? 25 : _context3.t0 === SERVER_ERROR ? 30 : 35;
              break;

            case 10:
              if (sessionId) {
                result.error = "Votre session a expirée";
              } else {
                result.error = "Vous n'êtes pas authentifié";
              }

              return _context3.abrupt("break", 37);

            case 12:
              result.error = "Accès interdit";
              return _context3.abrupt("break", 37);

            case 14:
              return _context3.abrupt("break", 37);

            case 15:
              result.error = "Opération non prise en charge";
              return _context3.abrupt("break", 37);

            case 17:
              result.error = "Erreur dans votre identifiant/mot de passe";
              return _context3.abrupt("break", 37);

            case 19:
              result.error = "Le nombre maximum de connexion autorisé par votre licence est atteint";
              return _context3.abrupt("break", 37);

            case 21:
              result.error = "Vous ne disposez pas d'une licence valide";
              return _context3.abrupt("break", 37);

            case 23:
              result.error = "Ce login/mot de passe existe sur plusieurs bases de données, connexion impossible";
              return _context3.abrupt("break", 37);

            case 25:
              _context3.next = 27;
              return response.json().then(function (response) {
                if (response.erreur) {
                  return response.erreur;
                } else if (response[resource] && response[resource].erreur) {
                  return response[resource].erreur;
                }

                return null;
              })["catch"](function (error) {
                return error;
              });

            case 27:
              dataErrorMsg = _context3.sent;
              result.error = dataErrorMsg;
              return _context3.abrupt("break", 37);

            case 30:
              _context3.next = 32;
              return response.text().then(function (response) {
                return response;
              })["catch"](function (error) {
                return error;
              });

            case 32:
              serverErrorMsg = _context3.sent;
              result.error = serverErrorMsg;
              return _context3.abrupt("break", 37);

            case 35:
              result.error = "Status code non pris en charge";
              return _context3.abrupt("break", 37);

            case 37:
              _context3.next = 40;
              break;

            case 39:
              result.error = "Erreur lors de l'exécution de la requête";

            case 40:
              return _context3.abrupt("return", result);

            case 41:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3);
    }));

    function _manageResponse(_x9, _x10, _x11) {
      return _manageResponse2.apply(this, arguments);
    }

    return _manageResponse;
  }() // #endregion
  ;

  return RequestUtils;
}(); // Exports


export var createResource = RequestUtils.createResource;
export var deleteResource = RequestUtils.deleteResource;
export var downloadFile = RequestUtils.downloadFile;
export var getResource = RequestUtils.getResource;
export var getResources = RequestUtils.getResources;
export var getResourcesWithParams = RequestUtils.getResourcesWithParams;
export var updateResource = RequestUtils.updateResource;